import { createField } from '@/components/forms/field.schema';
import {
  Calendar,
  FileText,
  Palette,
  ToggleLeft,
  Trash2,
  User,
} from 'lucide-react';
import { z } from 'zod';

export const labelFields = {
  name: createField(z.string().min(1, 'Name is required'), {
    fieldType: 'text',
    label: 'Name',
    placeholder: 'Enter label name',
    fullWidth: true,
  }),
  description: createField(z.string().optional(), {
    fieldType: 'textarea',
    label: 'Description',
    icon: FileText,
    placeholder: 'Optional description of the label',
    fullWidth: true,
  }),
  color: createField(
    z
      .string()
      .regex(/^[0-9a-fA-F]{6}$/, 'Color must be a valid 6-digit hex color')
      .nullable(),
    {
      fieldType: 'text',
      label: 'Color',
      placeholder: '999999',
      icon: Palette,
    },
  ),
  tickets: createField(z.boolean().default(true), {
    fieldType: 'boolean',
    label: 'Available for Tickets',
    icon: ToggleLeft,
  }),
  lists: createField(z.boolean().default(false), {
    fieldType: 'boolean',
    label: 'Available for Lists',
    icon: ToggleLeft,
  }),
  deleted: createField(z.boolean().default(false), {
    fieldType: 'boolean',
    label: 'Deleted',
    readOnly: true,
    icon: Trash2,
  }),
  created: createField(z.date(), {
    fieldType: 'date',
    label: 'Created',
    readOnly: true,
    icon: Calendar,
  }),
  modified: createField(z.date(), {
    fieldType: 'date',
    label: 'Modified',
    readOnly: true,
    icon: Calendar,
  }),
  editor_user_id: createField(z.number(), {
    fieldType: 'foreignKey',
    entity: 'user',
    label: 'Editor',
    readOnly: true,
    icon: User,
  }),
};
